import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-0f21852e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "post-slider-container" };
const _hoisted_2 = { class: "post-slider" };
const _hoisted_3 = { class: "post" };
const _hoisted_4 = { class: "subPost" };
const _hoisted_5 = { class: "titlePost" };
const _hoisted_6 = { class: "datePost" };
const _hoisted_7 = { class: "subPost" };
const _hoisted_8 = { class: "textPost" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "btnPost" }, "[READ]", -1));
const _hoisted_10 = { class: "bodyPost" };
const _hoisted_11 = { class: "catPost" };
const _hoisted_12 = { class: "imgPost" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mask" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Slide = _resolveComponent("Slide");
    const _component_Navigation = _resolveComponent("Navigation");
    const _component_Pagination = _resolveComponent("Pagination");
    const _component_Carousel = _resolveComponent("Carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Carousel, {
                "items-to-show": 4,
                "mouse-drag": true,
                modelValue: _ctx.currentSlide,
                class: "custom-carousel"
            }, {
                addons: _withCtx(() => [
                    _createVNode(_component_Navigation),
                    _createVNode(_component_Pagination)
                ]),
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                        return (_openBlock(), _createBlock(_component_Slide, {
                            key: post.id
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(post.title), 1),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(post.date), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(post.text), 1),
                                        _hoisted_9
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(post.label), 1),
                                        _createElementVNode("div", _hoisted_12, [
                                            _hoisted_13,
                                            _createElementVNode("div", {
                                                class: "wrap",
                                                style: _normalizeStyle({ backgroundImage: `url(/img/thumb/${post.photo})` })
                                            }, null, 4)
                                        ])
                                    ])
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            }, 8, ["modelValue"])
        ])
    ]));
}
